import React from "react";

/**
 * PageHeader — einheitlicher Page-Header für alle 6 Hauptseiten.
 *
 * Pattern:
 *   <PageHeader
 *     eyebrow="Newton Campus · Pipeline"
 *     title="Investoren"
 *     subtitle="Beschreibung was hier passiert."
 *     actions={<><Button>Bericht</Button><Button>Import</Button></>}
 *   />
 *
 * Konventionen (sync mit Top-Kandidaten / Investoren):
 *   - eyebrow:  pb-eyebrow (10px uppercase, navy/55)
 *   - title:    font-display font-bold text-2xl sm:text-[34px]  tracking -0.02em
 *   - subtitle: text-sm text-navy/55 font-sans, max-w-2xl
 *   - actions:  flex flex-wrap, rechts ausgerichtet (lg+) bzw. unter Subtitle (mobile)
 *
 * Margin/Padding: kein Wrapper-Container — die Page wrappt den Header bereits
 * (`pb-container`), so dass dieser sich an die Außenränder hält.
 */
export default function PageHeader({ eyebrow, title, subtitle, actions, testid }) {
  return (
    <header
      data-testid={testid || "page-header"}
      className="flex items-end justify-between flex-wrap gap-3"
    >
      <div className="min-w-0">
        {eyebrow && (
          <div className="pb-eyebrow" data-testid={testid ? `${testid}-eyebrow` : "page-header-eyebrow"}>
            {eyebrow}
          </div>
        )}
        <h1
          data-testid={testid ? `${testid}-title` : "page-header-title"}
          className="font-display font-bold text-navy text-2xl sm:text-[34px] tracking-[-0.02em] mt-2 leading-none break-words"
        >
          {title}
        </h1>
        {subtitle && (
          <p
            data-testid={testid ? `${testid}-subtitle` : "page-header-subtitle"}
            className="text-sm text-navy/55 font-sans mt-2 max-w-2xl"
          >
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div
          data-testid={testid ? `${testid}-actions` : "page-header-actions"}
          className="flex items-center gap-2 flex-wrap"
        >
          {actions}
        </div>
      )}
    </header>
  );
}
